export const dims = {
  minMaxPageWidth: 1280,
  maxMaxPageWidth: 3840,
  aspectRatio: 16.0 / 9.0,
  header: {
    height: '100px',
  },
  footer: {
    height: '100px',
  },
  warning: {
    height: '50px',
  },
  leftMenu: {
    width: '85%',
  },
  sideBar: {
    maxWidth: '250px',
  },
  icon: {
    tiny: '14px',
    small: '18px',
    medium: '24px',
    large: '32px',
    big: '48px',
    huge: '64px',
  },
  input: {
    borderRadius: '8px',
    height: '40px',
  },
  picker: {
    width: '220px',
    heightBox: '450px',
  },
};
